var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-config" },
    [
      _c(
        "el-form",
        {
          staticClass: "form",
          attrs: { model: _vm.form, "label-width": "90px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "类型：" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                _vm._l(_vm.pageTypeEnum, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "页面名称：" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入页面名称" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "页面标题：" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入页面标题" },
                on: {
                  input: function ($event) {
                    return _vm.updateConfig("title")
                  },
                },
                model: {
                  value: _vm.form.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "set-bg", attrs: { label: "背景设置：" } },
            [
              _c("div", { staticClass: "bg-checkbox" }, [
                _c(
                  "div",
                  { staticClass: "bg-checkbox-item" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { label: "bgImg" },
                        on: {
                          change: function (e) {
                            return _vm.updateBg(e, "isBgImg", "bgImg")
                          },
                        },
                        model: {
                          value: _vm.form.isBgImg,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isBgImg", $$v)
                          },
                          expression: "form.isBgImg",
                        },
                      },
                      [_vm._v("背景图片")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "bg-img",
                        on: {
                          click: function ($event) {
                            return _vm.uploadbgImg("bgImg")
                          },
                        },
                      },
                      [
                        _vm.form.bgImg
                          ? _c("img", { attrs: { src: _vm.form.bgImg } })
                          : _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "bg-checkbox-item" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { label: "bgColor" },
                        on: {
                          change: function (e) {
                            return _vm.updateBg(e, "isBgColor", "bgColor")
                          },
                        },
                        model: {
                          value: _vm.form.isBgColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isBgColor", $$v)
                          },
                          expression: "form.isBgColor",
                        },
                      },
                      [_vm._v("背景色")]
                    ),
                    _vm._v(" "),
                    _c("el-color-picker", {
                      attrs: { "show-alpha": "" },
                      on: {
                        change: function ($event) {
                          return _vm.changeBg("isBgColor", "bgColor")
                        },
                      },
                      model: {
                        value: _vm.form.bgColor,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bgColor", $$v)
                        },
                        expression: "form.bgColor",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "bg-checkbox-item" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { label: "bgColor" },
                        on: {
                          change: function (e) {
                            return _vm.updateBg(e, "isTextColor", "textColor")
                          },
                        },
                        model: {
                          value: _vm.form.isTextColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isTextColor", $$v)
                          },
                          expression: "form.isTextColor",
                        },
                      },
                      [_vm._v("文字颜色")]
                    ),
                    _vm._v(" "),
                    _c("el-color-picker", {
                      attrs: { "show-alpha": "" },
                      on: {
                        change: function ($event) {
                          return _vm.changeBg("isTextColor", "textColor")
                        },
                      },
                      model: {
                        value: _vm.form.textColor,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "textColor", $$v)
                        },
                        expression: "form.textColor",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "弹出广告：" } }, [
            _c(
              "div",
              { staticClass: "set-adv" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.form.isAdImg,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isAdImg", $$v)
                      },
                      expression: "form.isAdImg",
                    },
                  },
                  [_vm._v("开启弹出广告")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "adv-img",
                    on: {
                      click: function ($event) {
                        return _vm.uploadbgImg("adImg")
                      },
                    },
                  },
                  [
                    _vm.form.adImg
                      ? _c("img", { attrs: { src: _vm.form.adImg } })
                      : _c("i", {
                          staticClass: "el-icon-camera cameraIconfont",
                        }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.form.isAdImg
            ? _c(
                "el-form-item",
                { attrs: { label: "广告时间：" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "请输入广告时间" },
                      model: {
                        value: _vm.form.duration,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "duration", $$v)
                        },
                        expression: "form.duration",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("秒")])],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.isAdImg
            ? _c(
                "el-form-item",
                { attrs: { label: "跳转链接：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "append",
                          fn: function () {
                            return [
                              _c("i", {
                                staticClass: "el-icon-arrow-right",
                                on: {
                                  click: function ($event) {
                                    return _vm.openLink(_vm.index)
                                  },
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2490095510
                    ),
                    model: {
                      value: _vm.form.advUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "advUrl", $$v)
                      },
                      expression: "form.advUrl",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.isAdImg
            ? _c(
                "el-form-item",
                { attrs: { label: "间隔时间：" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "请输入间隔时间" },
                      model: {
                        value: _vm.form.adInterval,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "adInterval", $$v)
                        },
                        expression: "form.adInterval",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("小时")])],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("linkaddressVue", {
        ref: "linkaddressVueRef",
        on: { linkUrl: _vm.linkUrl },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }